<script setup>
import { guestNameService } from '@/services/guest-name.service';
import { ref } from 'vue'

const guestName = ref('')

function submit() {
    if (guestName.value.trim()) {
        guestNameService.set(guestName.value.trim())
    }
}
</script>

<template>
    <div class="card flex-row align-items-center form-group gap-3 justify-self-center">
        <label for="guestName" class="greeting">Xin chào:</label>
        <input type="text" id="guestName" v-model="guestName" required placeholder="Tên bạn là gì?" />
        <button @click="submit" class=" submit-button m-0">
            <i class="pi pi-chevron-right"></i>
        </button>
    </div>
</template>


<style scoped>
.greeting {
    width: 8rem;
}

.card {
    width: 100%;
    max-width: 600px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
}

@media screen and (max-width: 768px) {
    .card {
        width: 90%;
    }
}
</style>